import { Controller } from "stimulus";

// Brings the picked chip into view when the row scrolls sideways on a phone.
export default class SeasonChipsController extends Controller {
  connect() {
    const active = this.element.querySelector('[aria-current="true"]');
    if (!active) return;

    const row = this.element;
    row.scrollLeft = active.offsetLeft - (row.clientWidth - active.offsetWidth) / 2;
  }
}
